
import Vue from 'vue'
import ModalOverlay from '@/common/components/ModalOverlay.vue'
import { ENDPOINTS } from '@/product/const'
import axios from '@/common/utils/axios_utils'
import Skeleton from '@/common/components/Skeleton.vue'
import ProductPreviewModalFooter from './ProductPreviewModalFooter.vue'
import ProductPreviewModalImages from './ProductPreviewModalImages.vue'
import ProductPreviewOptions from './ProductPreviewOptions.vue'
import ProductPreviewEditPattern from './ProductPreviewEditPattern.vue'
import ProductPreviewColorPattern from './ProductPreviewColorPattern.vue'
import ProductPreviewDetails from './ProductPreviewDetails.vue'
import { formatSliceYear } from '@/common/utils/common'
import { SYSTEM_ERROR } from '@/common/constants'
import { captureException } from '@sentry/browser'

export default Vue.extend({
  components: {
    ModalOverlay,
    Skeleton,
    ProductPreviewModalFooter,
    ProductPreviewModalImages,
    ProductPreviewOptions,
    ProductPreviewEditPattern,
    ProductPreviewColorPattern,
    ProductPreviewDetails
  },
  props: {
    initProductId: {
      type: String,
      required: true
    },
    productGroupIds: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      skuImages: [],
      productName: '',
      firstSkuSelectionName: '',
      firstOptions: [],
      secondSkuSelectionName: '',
      secondOptions: [],
      colorPatternOptions: [],
      editPatternOptions: [],
      detail: '',
      estimateItemId: '',
      loaded: false,
      productId: '',
      shortestShippingDate: '',
      quantityUnit: '',
      minPrice: 0,
      minQuantity: 0,
      maxQuantity: 0,
      hasStock: false
    }
  },
  computed: {
    currentEstimateItemId(): string {
      return this.estimateItemId ? this.estimateItemId.toString() : ''
    },
    currentEstimateProductId(): number {
      return this.productId ? Number(this.productId) : 0
    },
    currentProductIndex(): number {
      return this.productGroupIds.indexOf(this.productId)
    },
    disablePrevBtn() {
      return this.currentProductIndex === 0
    },
    disableNextBtn() {
      return this.currentProductIndex === this.productGroupIds.length - 1
    }
  },
  mounted() {
    this.productId = this.initProductId
    this.showDetailModal(this.productId)
  },
  methods: {
    formatSliceYear,
    closeModal() {
      this.$emit('closeModal')
    },
    prevProduct() {
      if (this.currentProductIndex === 0 ) return
      if (this.currentProductIndex > 0) {
        this.productId = this.productGroupIds[this.currentProductIndex - 1]
        this.showDetailModal(this.productId)
      }
    },
    nextProduct() {
      if (this.currentProductIndex === this.productGroupIds.length - 1) return
      this.productId = this.productGroupIds[this.currentProductIndex + 1]
      this.showDetailModal(this.productId)
    },
    setProductValues(data: any) {
      this.skuImages = data.sku_images
      this.productName = data.display_name
      this.firstSkuSelectionName = data.estimate.first_selected_option.sku_selection_name ?? ''
      this.firstOptions = data.first_options
      this.secondSkuSelectionName = data.estimate.second_selected_option.sku_selection_name ?? ''
      this.secondOptions = data.second_options
      this.colorPatternOptions = data.color_pattern_options
      this.editPatternOptions = data.edit_pattern_options
      this.detail = data.detail
      this.estimateItemId = data.estimate_item_id ? data.estimate_item_id.toString() : ''
      this.shortestShippingDate = data.estimate.shortest_shipping_date
      this.quantityUnit = data.quantity_unit
      this.minPrice = data.lowest_price
      this.minQuantity = data.estimate.min_quantity
      this.maxQuantity = data.estimate.max_quantity
      this.hasStock = data.has_stock
    },
    async showDetailModal(productId: string) {
      this.loaded = false

      try {
        const url = ENDPOINTS.PRODUCTS.replace(/%id/, productId)
        const response = await axios.get(url)
        this.setProductValues(response.data)
        this.loaded = true
      } catch (error) {
        captureException(`Failed to fetch product detail: ${error}, id: ${productId}`)
        alert(SYSTEM_ERROR.UNKNOWN)
      }
    }
  }
})
